/* CALFTALK Loopagenda
 * Progressive enhancement on top of the server-rendered race list:
 * Leaflet map (self-hosted, CARTO light basemap), filters and branded
 * .ics downloads. Without JS the full list stays visible; the map and
 * tools remain hidden.
 */
(function () {
  'use strict';

  var MAAND_LANG = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

  function init() {
    var dataEl = document.querySelector('[data-agenda-data]');
    var list = document.querySelector('[data-agenda-list]');
    if (!dataEl || !list) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    function toDate(s) {
      var p = s.split('-');
      return new Date(+p[0], +p[1] - 1, +p[2]);
    }
    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function dutchDate(s) {
      var d = toDate(s);
      return d.getDate() + ' ' + MAAND_LANG[d.getMonth()] + ' ' + d.getFullYear();
    }

    var races = (data.races || []).filter(function (r) {
      var end = r.end || r.start;
      return r.start && toDate(end) >= today;
    });
    races.sort(function (a, b) {
      return a.start < b.start ? -1 : 1;
    });
    var byId = {};
    races.forEach(function (r) {
      byId[r.id] = r;
    });

    var cards = {};
    list.querySelectorAll('[data-agenda-card]').forEach(function (card) {
      var id = card.getAttribute('data-id');
      cards[id] = card;
      if (!byId[id]) card.hidden = true;
    });

    // Keep the visible order date-ascending even if the server order drifts.
    races.forEach(function (r) {
      if (cards[r.id]) list.appendChild(cards[r.id]);
    });

    // Agenda-knoppen staan in Liquid verborgen omdat ze JavaScript nodig hebben.
    list.querySelectorAll('[data-agenda-ics]').forEach(function (btn) {
      btn.hidden = false;
    });

    /* ---------- filters ---------- */
    var tools = document.querySelector('[data-agenda-tools]');
    var countEl = document.querySelector('[data-agenda-count]');
    var emptyEl = document.querySelector('[data-agenda-empty]');
    var F = { q: '', month: '', kinds: {}, province: '', checkedOnly: false, center: null, radiusKm: 25 };

    var PROVINCIES = {
      drenthe: 'Drenthe',
      flevoland: 'Flevoland',
      friesland: 'Friesland',
      gelderland: 'Gelderland',
      groningen: 'Groningen',
      limburg: 'Limburg',
      'noord-brabant': 'Noord-Brabant',
      'noord-holland': 'Noord-Holland',
      overijssel: 'Overijssel',
      utrecht: 'Utrecht',
      zeeland: 'Zeeland',
      'zuid-holland': 'Zuid-Holland',
    };

    if (tools) {
      tools.hidden = false;

      var monthSel = tools.querySelector('[data-agenda-month]');
      var seenMonths = {};
      races.forEach(function (r) {
        var d = toDate(r.start);
        var key = d.getFullYear() + '-' + d.getMonth();
        if (seenMonths[key]) return;
        seenMonths[key] = true;
        var o = document.createElement('option');
        o.value = key;
        o.textContent = MAAND_LANG[d.getMonth()] + ' ' + d.getFullYear();
        monthSel.appendChild(o);
      });

      tools.querySelectorAll('[data-agenda-kind]').forEach(function (chip) {
        var kind = chip.getAttribute('data-agenda-kind');
        var used = races.some(function (r) {
          return (r.kinds || []).indexOf(kind) > -1;
        });
        if (!used) chip.hidden = true;
      });

      var provSel = tools.querySelector('[data-agenda-province]');
      if (provSel) {
        Object.keys(PROVINCIES)
          .filter(function (slug) {
            return races.some(function (r) {
              return r.region === slug;
            });
          })
          .forEach(function (slug) {
            var o = document.createElement('option');
            o.value = slug;
            o.textContent = PROVINCIES[slug];
            provSel.appendChild(o);
          });
      }
    }

    function activeKeys(bag) {
      return Object.keys(bag).filter(function (k) {
        return bag[k];
      });
    }

    function distanceKm(lat1, lng1, lat2, lng2) {
      var rad = Math.PI / 180;
      var dLat = (lat2 - lat1) * rad;
      var dLng = (lng2 - lng1) * rad;
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function matches(race) {
      var kinds = activeKeys(F.kinds);
      if (F.center) {
        if (typeof race.lat !== 'number' || typeof race.lng !== 'number') return false;
        if (distanceKm(F.center.lat, F.center.lng, race.lat, race.lng) > F.radiusKm) return false;
      }
      if (F.province && race.region !== F.province) return false;
      if (
        kinds.length &&
        !kinds.some(function (k) {
          return (race.kinds || []).indexOf(k) > -1;
        })
      )
        return false;
      if (F.month !== '') {
        var d = toDate(race.start);
        if (d.getFullYear() + '-' + d.getMonth() !== F.month) return false;
      }
      if (F.checkedOnly && race.src !== 'org') return false;
      if (F.q) {
        var hay = [race.name, race.city, race.travel, race.note, (race.dist || []).join(' ')].join(' ').toLowerCase();
        if (hay.indexOf(F.q) < 0) return false;
      }
      return true;
    }

    /* De lijst toont een eerste lading en groeit op verzoek. De kaart toont
     * altijd alle treffers: dat is juist het overzicht. */
    var PAGE_SIZE = 12;
    var shownLimit = PAGE_SIZE;
    var matching = [];
    var moreBtn = document.querySelector('[data-agenda-more]');

    function renderList() {
      races.forEach(function (race) {
        var card = cards[race.id];
        if (card) card.hidden = true;
      });
      matching.slice(0, shownLimit).forEach(function (race) {
        var card = cards[race.id];
        if (card) card.hidden = false;
      });

      var total = matching.length;
      var shown = Math.min(shownLimit, total);
      if (countEl) {
        countEl.textContent =
          total === 0
            ? '0 wedstrijden'
            : shown < total
              ? shown + ' van ' + total + ' wedstrijden'
              : total + (total === 1 ? ' wedstrijd' : ' wedstrijden');
      }
      if (moreBtn) {
        var rest = total - shown;
        moreBtn.hidden = rest <= 0;
        if (rest > 0) {
          moreBtn.textContent = 'Toon ' + Math.min(PAGE_SIZE, rest) + ' meer (nog ' + rest + ')';
        }
      }
      if (emptyEl) emptyEl.hidden = total !== 0;
    }

    function applyFilters() {
      matching = races.filter(matches);
      var keep = {};
      matching.forEach(function (race) {
        keep[race.id] = true;
      });
      races.forEach(function (race) {
        var marker = markers[race.id];
        if (!marker || !map) return;
        if (keep[race.id] && !map.hasLayer(marker)) marker.addTo(map);
        if (!keep[race.id] && map.hasLayer(marker)) map.removeLayer(marker);
      });
      shownLimit = PAGE_SIZE;
      renderList();
    }

    /* ---------- map ---------- */
    var mapEl = document.querySelector('[data-agenda-map]');
    var map = null;
    var markers = {};
    var geocodeStarted = false;

    function statusLine(race) {
      var parts = [];
      if (race.status === 'open') parts.push('Inschrijving open');
      else if (race.status === 'deels') parts.push('Deels uitverkocht');
      else parts.push('Status: check de site');
      if (race.regOpen && toDate(race.regOpen) > today) {
        parts.push('inschrijving opent ' + dutchDate(race.regOpen));
      }
      return parts.join(' · ');
    }

    function popupHTML(race) {
      var when = dutchDate(race.start);
      if (race.end && race.end !== race.start) {
        var de = toDate(race.end);
        when = toDate(race.start).getDate() + ' t/m ' + de.getDate() + ' ' + MAAND_LANG[de.getMonth()] + ' ' + de.getFullYear();
      }
      var html = '<h4 class="calftalk-agenda__popup-name">' + esc(race.name) + '</h4>';
      html += '<p class="calftalk-agenda__popup-meta">' + esc(when) + ' · ' + esc(race.city) + '</p>';
      if (race.dist && race.dist.length) {
        html +=
          '<ul class="calftalk-agenda__popup-dists">' +
          race.dist
            .map(function (x) {
              return '<li>' + esc(x) + '</li>';
            })
            .join('') +
          '</ul>';
      }
      html += '<p class="calftalk-agenda__popup-status">' + esc(statusLine(race)) + '</p>';
      if (race.note) {
        var note = race.note.length > 170 ? race.note.slice(0, 167) + '…' : race.note;
        html += '<p class="calftalk-agenda__popup-note">' + esc(note) + '</p>';
      }
      html += '<div class="calftalk-agenda__popup-actions">';
      if (race.url) {
        var label = race.status === 'open' ? 'Inschrijven' : 'Naar de website';
        html += '<a class="calftalk-btn calftalk-btn--primary" href="' + esc(race.url) + '" target="_blank" rel="noopener">' + label + '</a>';
      }
      html += '<button class="calftalk-btn" type="button" data-agenda-ics="' + esc(race.id) + '">Zet in je agenda</button>';
      html += '</div>';
      return html;
    }

    var OSM_ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>';
    var ESRI_ATTR = 'Tiles &copy; <a href="https://www.esri.com/" target="_blank" rel="noopener">Esri</a>';

    var MAPTILER_ATTR = '&copy; <a href="https://www.maptiler.com/copyright/" target="_blank" rel="noopener">MapTiler</a> ' + OSM_ATTR;

    function maptilerProvider(styleId, key) {
      // MapTiler raster tiles are 512px; without tileSize/zoomOffset the
      // labels render at half size.
      return {
        url: 'https://api.maptiler.com/maps/' + styleId + '/{z}/{x}/{y}.png?key=' + encodeURIComponent(key),
        options: { attribution: MAPTILER_ATTR, tileSize: 512, zoomOffset: -1 },
      };
    }

    function tileConfig() {
      var style = mapEl.getAttribute('data-map-style') || 'esri_topo';
      var key = mapEl.getAttribute('data-maptiler-key') || '';
      var providers = {
        esri_topo: {
          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
          options: { attribution: ESRI_ATTR },
        },
        esri_gray: {
          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
          options: { attribution: ESRI_ATTR, maxZoom: 16 },
        },
        osm: {
          url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
          options: { attribution: OSM_ATTR },
        },
        maptiler: maptilerProvider('bright-v2', key),
        maptiler_streets: maptilerProvider('streets-v2', key),
        maptiler_pastel: maptilerProvider('pastel', key),
      };
      if (style.indexOf('maptiler') === 0 && !key) style = 'esri_topo';
      return providers[style] || providers.esri_topo;
    }

    function initMap() {
      if (!mapEl || typeof window.L === 'undefined' || map) return;
      map = window.L.map(mapEl, {
        // Gewoon scrollen blijft de pagina scrollen: de kaart kaapt hem nooit.
        // Zoomen gaat met pinch (zie hieronder), de knoppen of dubbelklikken.
        scrollWheelZoom: false,
        // Vloeiende tussenstappen, anders springt pinchen per hele zoomstap.
        zoomSnap: 0,
        zoomDelta: 0.5,
        attributionControl: true,
        minZoom: 6,
        maxZoom: 17,
      });
      var tiles = tileConfig();
      window.L.tileLayer(tiles.url, tiles.options).addTo(map);

      // Browsers vertalen een trackpad-pinch naar een wheel-event met ctrlKey.
      // Daarop zoomen we wel, en dan richting de cursor.
      mapEl.addEventListener(
        'wheel',
        function (ev) {
          if (!ev.ctrlKey) return;
          ev.preventDefault();
          var rect = mapEl.getBoundingClientRect();
          var point = window.L.point(ev.clientX - rect.left, ev.clientY - rect.top);
          var step = Math.max(-8, Math.min(8, ev.deltaY)) * 0.02;
          var zoom = map.getZoom() - step;
          zoom = Math.max(map.getMinZoom(), Math.min(map.getMaxZoom(), zoom));
          map.setZoomAround(point, zoom, { animate: false });
        },
        { passive: false }
      );

      races.forEach(addMarker);
      fitToMarkers();
      applyFilters();
      geocodeMissing();
    }

    function addMarker(race) {
      if (!map || markers[race.id]) return;
      if (typeof race.lat !== 'number' || typeof race.lng !== 'number') return;
      var icon = window.L.divIcon({
        className: 'calftalk-agenda__pin' + (race.hero ? ' calftalk-agenda__pin--hero' : ''),
        html: '<span></span>',
        iconSize: race.hero ? [26, 26] : [20, 20],
        iconAnchor: race.hero ? [13, 26] : [10, 20],
        popupAnchor: [0, -22],
      });
      var marker = window.L.marker([race.lat, race.lng], { icon: icon, title: race.name });
      marker.bindTooltip(race.name, {
        className: 'calftalk-agenda__tooltip',
        direction: 'top',
        offset: [0, -22],
      });
      marker.bindPopup(popupHTML(race), {
        className: 'calftalk-agenda__popup',
        maxWidth: Math.min(320, window.innerWidth - 80),
      });
      marker.addTo(map);
      markers[race.id] = marker;
    }

    function fitToMarkers() {
      if (!map) return;
      var bounds = races
        .filter(function (r) {
          return typeof r.lat === 'number' && typeof r.lng === 'number';
        })
        .map(function (r) {
          return [r.lat, r.lng];
        });
      if (bounds.length) {
        map.fitBounds(bounds, { padding: [40, 40] });
      } else {
        map.setView([52.2, 5.3], 7);
      }
    }

    /* Races saved without coordinates get located from their place name,
     * so the admin never has to look up lat/lng by hand. Results are
     * cached per browser to keep repeat visits free of lookups. */
    function geocodeMissing() {
      if (geocodeStarted) return;
      var todo = races.filter(function (r) {
        return (typeof r.lat !== 'number' || typeof r.lng !== 'number') && r.city;
      });
      if (!todo.length) return;
      geocodeStarted = true;
      var done = 0;
      todo.forEach(function (race) {
        geocodePlace(race.city).then(function (coords) {
          done++;
          if (coords) {
            race.lat = coords.lat;
            race.lng = coords.lng;
            addMarker(race);
          }
          if (done === todo.length) {
            if (!F.center) fitToMarkers();
            applyFilters();
          }
        });
      });
    }

    function geocodePlace(place) {
      var query = String(place).split(/[→>\/,(]/)[0].trim();
      if (!query) return Promise.resolve(null);
      var cacheKey = 'calftalk_geo_v1_' + query.toLowerCase();
      try {
        var cached = localStorage.getItem(cacheKey);
        if (cached) {
          var parts = cached.split(',');
          var lat = parseFloat(parts[0]);
          var lng = parseFloat(parts[1]);
          if (!isNaN(lat) && !isNaN(lng)) return Promise.resolve({ lat: lat, lng: lng });
        }
      } catch (e) {
        /* storage unavailable, fall through to a live lookup */
      }
      var url =
        'https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?rows=1&fq=type:woonplaats&fl=centroide_ll&q=' +
        encodeURIComponent(query);
      return fetch(url)
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          var doc = json && json.response && json.response.docs && json.response.docs[0];
          var point = doc && doc.centroide_ll && doc.centroide_ll.match(/POINT\(([0-9.]+) ([0-9.]+)\)/);
          if (!point) return null;
          var coords = { lat: parseFloat(point[2]), lng: parseFloat(point[1]) };
          try {
            localStorage.setItem(cacheKey, coords.lat + ',' + coords.lng);
          } catch (e) {
            /* cache is a nicety, not a requirement */
          }
          return coords;
        })
        .catch(function () {
          return null;
        });
    }

    if (mapEl) {
      if (typeof window.L !== 'undefined') {
        initMap();
      } else {
        window.addEventListener('load', initMap);
      }
    }

    /* ---------- .ics download ---------- */
    function icsEscape(s) {
      return String(s == null ? '' : s)
        .replace(/\\/g, '\\\\')
        .replace(/;/g, '\\;')
        .replace(/,/g, '\\,')
        .replace(/\r?\n/g, '\\n');
    }

    function downloadIcs(race) {
      var startStr = race.start.replace(/-/g, '');
      var endDate = toDate(race.end || race.start);
      endDate.setDate(endDate.getDate() + 1);
      var endStr = endDate.getFullYear() + pad(endDate.getMonth() + 1) + pad(endDate.getDate());
      var now = new Date();
      var stamp =
        now.getUTCFullYear() +
        pad(now.getUTCMonth() + 1) +
        pad(now.getUTCDate()) +
        'T' +
        pad(now.getUTCHours()) +
        pad(now.getUTCMinutes()) +
        pad(now.getUTCSeconds()) +
        'Z';
      var description =
        (race.note ? race.note + '\n\n' : '') +
        'Inschrijven: ' +
        (race.url || '') +
        '\n\nUit de CALFTALK Loopagenda · ' +
        (data.pageUrl || data.shopUrl || 'https://calftalk.com');
      var lines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//CALFTALK//Loopagenda//NL',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        'UID:' + race.id + '@calftalk.com',
        'DTSTAMP:' + stamp,
        'DTSTART;VALUE=DATE:' + startStr,
        'DTEND;VALUE=DATE:' + endStr,
        'SUMMARY:' + icsEscape('🏃 ' + race.name + ' · CALFTALK Loopagenda'),
        'LOCATION:' + icsEscape((race.city || '') + ', Nederland'),
        'DESCRIPTION:' + icsEscape(description),
        race.url ? 'URL:' + icsEscape(race.url) : null,
        'BEGIN:VALARM',
        'TRIGGER:-P7D',
        'ACTION:DISPLAY',
        'DESCRIPTION:' + icsEscape('Nog een week tot ' + race.name + '. Sokken klaar? · CALFTALK'),
        'END:VALARM',
        'END:VEVENT',
        'END:VCALENDAR',
      ].filter(Boolean);
      var blob = new Blob([lines.join('\r\n') + '\r\n'], { type: 'text/calendar;charset=utf-8' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'calftalk-' + race.id + '.ics';
      document.body.appendChild(a);
      a.click();
      setTimeout(function () {
        URL.revokeObjectURL(a.href);
        a.remove();
      }, 1000);
    }

    /* ---------- events ---------- */
    document.addEventListener('click', function (ev) {
      var target = ev.target.closest('button');
      if (!target) return;

      if (target.hasAttribute('data-agenda-kind')) {
        toggleChip(target, F.kinds, target.getAttribute('data-agenda-kind'));
      } else if (target.hasAttribute('data-agenda-checked-only')) {
        var on = target.getAttribute('aria-pressed') === 'true';
        target.setAttribute('aria-pressed', String(!on));
        F.checkedOnly = !on;
        applyFilters();
      } else if (target.hasAttribute('data-agenda-more')) {
        shownLimit += PAGE_SIZE;
        renderList();
      } else if (target.hasAttribute('data-agenda-ics')) {
        var icsRace = byId[target.getAttribute('data-agenda-ics')];
        if (icsRace) downloadIcs(icsRace);
      }
    });

    function toggleChip(chip, bag, key) {
      var on = chip.getAttribute('aria-pressed') === 'true';
      chip.setAttribute('aria-pressed', String(!on));
      bag[key] = !on;
      applyFilters();
    }

    var searchInput = document.querySelector('[data-agenda-search]');
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        F.q = this.value.trim().toLowerCase();
        applyFilters();
      });
    }
    var monthSelect = document.querySelector('[data-agenda-month]');
    if (monthSelect) {
      monthSelect.addEventListener('change', function () {
        F.month = this.value;
        applyFilters();
      });
    }
    var provinceSelect = document.querySelector('[data-agenda-province]');
    if (provinceSelect) {
      provinceSelect.addEventListener('change', function () {
        F.province = this.value;
        applyFilters();
      });
    }

    /* ---------- postcode radius (PDOK Locatieserver, keyless) ---------- */
    var pcInput = document.querySelector('[data-agenda-postcode]');
    var radiusSelect = document.querySelector('[data-agenda-radius]');
    var radiusClear = document.querySelector('[data-agenda-radius-clear]');
    var radiusMsg = document.querySelector('[data-agenda-radius-msg]');
    var radiusCircle = null;
    var pcTimer = null;

    function drawRadius() {
      if (!map || typeof window.L === 'undefined') return;
      if (radiusCircle) {
        map.removeLayer(radiusCircle);
        radiusCircle = null;
      }
      if (!F.center) return;
      radiusCircle = window.L.circle([F.center.lat, F.center.lng], {
        radius: F.radiusKm * 1000,
        color: '#FF4A1F',
        weight: 2,
        fillColor: '#FF4A1F',
        fillOpacity: 0.06,
      }).addTo(map);
      map.fitBounds(radiusCircle.getBounds(), { padding: [30, 30] });
    }

    function setRadiusMessage(text) {
      if (!radiusMsg) return;
      radiusMsg.hidden = !text;
      radiusMsg.textContent = text || '';
    }

    function clearRadius() {
      F.center = null;
      if (pcInput) pcInput.value = '';
      if (radiusClear) radiusClear.hidden = true;
      setRadiusMessage('');
      drawRadius();
      applyFilters();
    }

    function geocodePostcode(raw) {
      var pc = raw.replace(/\s+/g, '').toUpperCase();
      if (!/^[1-9][0-9]{3}([A-Z]{2})?$/.test(pc)) {
        setRadiusMessage('Vul een Nederlandse postcode in, bv. 2011 AB');
        return;
      }
      setRadiusMessage('Zoeken…');
      var url =
        'https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?rows=1&fq=type:postcode&fl=weergavenaam,centroide_ll&q=' +
        encodeURIComponent(pc);
      fetch(url)
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          var doc = json && json.response && json.response.docs && json.response.docs[0];
          var point = doc && doc.centroide_ll && doc.centroide_ll.match(/POINT\(([0-9.]+) ([0-9.]+)\)/);
          if (!point) {
            setRadiusMessage('Postcode niet gevonden');
            return;
          }
          F.center = { lat: parseFloat(point[2]), lng: parseFloat(point[1]) };
          if (radiusClear) radiusClear.hidden = false;
          setRadiusMessage('Binnen ' + F.radiusKm + ' km van ' + pc);
          drawRadius();
          applyFilters();
        })
        .catch(function () {
          setRadiusMessage('Zoeken lukt even niet, probeer het later opnieuw');
        });
    }

    if (pcInput) {
      pcInput.addEventListener('input', function () {
        var value = this.value;
        clearTimeout(pcTimer);
        if (!value.trim()) {
          clearRadius();
          return;
        }
        pcTimer = setTimeout(function () {
          geocodePostcode(value);
        }, 500);
      });
      pcInput.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter') {
          ev.preventDefault();
          clearTimeout(pcTimer);
          geocodePostcode(this.value);
        }
      });
    }
    if (radiusSelect) {
      F.radiusKm = parseInt(radiusSelect.value, 10) || 25;
      radiusSelect.addEventListener('change', function () {
        F.radiusKm = parseInt(this.value, 10) || 25;
        if (F.center) {
          setRadiusMessage('Binnen ' + F.radiusKm + ' km van ' + (pcInput ? pcInput.value.toUpperCase() : ''));
          drawRadius();
          applyFilters();
        }
      });
    }
    if (radiusClear) {
      radiusClear.addEventListener('click', clearRadius);
    }

    applyFilters();
    // With the map switched off, the radius filter still needs coordinates.
    if (!mapEl) geocodeMissing();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
